"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var coordinate_diagnosis_1 = require("../../../shared/model/coordinate-diagnosis");
var diagnosis_web_socket_service_1 = require("../../service/diagnosis-web-socket.service");
var diagnosis_service_1 = require("../../service/diagnosis.service");
var toast_service_1 = require("../../../shared/service/toast.service");
var diagnosis_item_status_1 = require("../../model/diagnosis-item-status");
var CanDiagnosisComponent = /** @class */ (function () {
    function CanDiagnosisComponent(_diagnosisNotification, _diagnosiService, _toastService) {
        this._diagnosisNotification = _diagnosisNotification;
        this._diagnosiService = _diagnosiService;
        this._toastService = _toastService;
        this.running = true;
        this.canEnabledAttribute = "Ativação da CAN";
        this.hasError = false;
    }
    CanDiagnosisComponent.prototype.ngOnInit = function () {
        if (this._run) {
            this.observeRestart();
            this.observeBack();
            this.setEmptyEntities();
            this.subscribeRunning();
            this.subscribeSuccess();
            this.subscribeFail();
            this.subscribeTimeout();
            this.subscribeError();
        }
        else {
            this.displayViewMode();
        }
    };
    Object.defineProperty(CanDiagnosisComponent.prototype, "run", {
        get: function () {
            return this._run;
        },
        set: function (run) {
            this._run = run;
        },
        enumerable: true,
        configurable: true
    });
    CanDiagnosisComponent.prototype.canWasEnabled = function () {
        var _this = this;
        var enabled = false;
        this.canParams.forEach(function (element) {
            if (element.attribute === _this.canEnabledAttribute) {
                enabled = element.status === diagnosis_item_status_1.DiagnosisItemStatus.SUCCESS;
            }
        });
        return enabled;
    };
    CanDiagnosisComponent.prototype.hasCanActivationTimeout = function () {
        var _this = this;
        var has = true;
        this.canParams.forEach(function (element) {
            if (element.attribute === _this.canEnabledAttribute) {
                has = element.status === diagnosis_item_status_1.DiagnosisItemStatus.RUNNING;
            }
        });
        return has;
    };
    CanDiagnosisComponent.prototype.displayViewMode = function () {
        // TODO display view mode for future attending diagnosis
    };
    CanDiagnosisComponent.prototype.observeRestart = function () {
        var _this = this;
        this._diagnosisNotification.restart$
            .subscribe(function () {
            _this.setEmptyEntities();
            _this.running = true;
            _this.hasError = false;
        });
    };
    CanDiagnosisComponent.prototype.observeBack = function () {
        var _this = this;
        this._diagnosisNotification.back$
            .subscribe(function () {
            _this.setEmptyEntities();
            _this.running = false;
            _this.hasError = false;
        });
    };
    CanDiagnosisComponent.prototype.setEmptyEntities = function () {
        this.canParams = [];
        this.coordinateCanParams = {};
        this.errorType = undefined;
        this.trnRsnIds = [];
    };
    CanDiagnosisComponent.prototype.subscribeSuccess = function () {
        var _this = this;
        this._diagnosisNotification.success$
            .filter(function (data) { return data instanceof coordinate_diagnosis_1.CoordinateDiagnosis; })
            .subscribe(function (coordinateDiagnosis) {
            _this.setAttributeState(coordinateDiagnosis, diagnosis_item_status_1.DiagnosisItemStatus.SUCCESS);
            _this.updateDiagnosisDisplay(coordinateDiagnosis);
        });
    };
    CanDiagnosisComponent.prototype.subscribeFail = function () {
        var _this = this;
        this._diagnosisNotification.failed$
            .filter(function (data) { return data instanceof coordinate_diagnosis_1.CoordinateDiagnosis; })
            .subscribe(function (coordinateDiagnosis) {
            _this.setAttributeState(coordinateDiagnosis, diagnosis_item_status_1.DiagnosisItemStatus.FAILED);
            _this.updateDiagnosisDisplay(coordinateDiagnosis);
        });
    };
    CanDiagnosisComponent.prototype.subscribeRunning = function () {
        var _this = this;
        this._diagnosisNotification.running$
            .filter(function (data) { return data instanceof coordinate_diagnosis_1.CoordinateDiagnosis; })
            .subscribe(function (coordinateDiagnosis) {
            _this.setAttributesToRunning(coordinateDiagnosis);
            _this.updateDiagnosisDisplay(coordinateDiagnosis);
        });
    };
    CanDiagnosisComponent.prototype.subscribeTimeout = function () {
        var _this = this;
        this._diagnosisNotification.timeout$
            .filter(function (data) { return data instanceof coordinate_diagnosis_1.CoordinateDiagnosis; })
            .subscribe(function (coordinateDiagnosis) {
            _this.trnRsnIds = coordinateDiagnosis.trnRsnIds;
            _this.setAttributeState(coordinateDiagnosis, diagnosis_item_status_1.DiagnosisItemStatus.TIMEOUT);
            _this.updateDiagnosisDisplay(coordinateDiagnosis);
        });
    };
    CanDiagnosisComponent.prototype.restartDiagnosis = function () {
        this._diagnosisNotification.restart();
        this.running = true;
        this.hasError = false;
    };
    CanDiagnosisComponent.prototype.subscribeError = function () {
        var _this = this;
        this._diagnosisNotification.error$
            .subscribe(function (data) {
            _this.setEmptyEntities();
            _this.running = false;
            _this.hasError = true;
            _this.errorType = data.error;
        });
    };
    CanDiagnosisComponent.prototype.setAttributeState = function (coordinateResponse, status) {
        var _this = this;
        Object.keys(coordinateResponse.canParams).forEach(function (key) {
            if (!(key in _this.coordinateCanParams)) {
                _this.updateCanParamStatus(key, coordinateResponse.canParams[key], status);
            }
        });
    };
    CanDiagnosisComponent.prototype.updateCanParamStatus = function (attribute, value, status) {
        var _this = this;
        this.canParams.forEach(function (element) {
            if (element.attribute === attribute) {
                element.status = status;
                element.value = value;
                _this.coordinateCanParams[attribute] = status;
            }
        });
    };
    CanDiagnosisComponent.prototype.setAttributesToRunning = function (coordinateResponse) {
        var _this = this;
        this.canParams = [];
        Object.keys(coordinateResponse.canParams).forEach(function (key) {
            _this.canParams.push(({
                attribute: key,
                value: coordinateResponse.canParams[key],
                status: diagnosis_item_status_1.DiagnosisItemStatus.RUNNING
            }));
        });
    };
    CanDiagnosisComponent.prototype.updateDiagnosisDisplay = function (coordinateResponse) {
        this.running = coordinateResponse.isRunning;
    };
    CanDiagnosisComponent.ctorParameters = function () { return [{ type: diagnosis_web_socket_service_1.DiagnosisWebSocketService }, { type: diagnosis_service_1.DiagnosisService }, { type: toast_service_1.ToastService }]; };
    return CanDiagnosisComponent;
}());
exports.CanDiagnosisComponent = CanDiagnosisComponent;
//# sourceMappingURL=can-diagnosis.component.js.map


// WEBPACK FOOTER //
// can-diagnosis.component.js